import { ColumnType, SearchType, SortType } from './criteria.model';

export interface BaseFpxRoGridHandleAction {
  (action: string, data: any): void;
}

export interface BaseFpxRoGridDisableAction{
  (action : string , data : any) : boolean
}

export interface IColumnArray<T> {
  action :'sort' | 'search' | 'sort&search' | undefined;
  columnDef: string;
  header: string;
  width: number | string;
  cell?: (element: T) => string;
  columnType: ColumnType | undefined;
  searchType: SearchType | undefined;
  sortType: SortType | undefined ;
  searchText: string | string[];
  fromValue?: string;
  toValue?: string;
}
export interface ToolBar {
  type: 'icon' | 'button';
  key: string;
  name: string;
  hoverText?: string;
  required? : (name : string ,data:any) => boolean;
}

export interface SortSearch {
  action: 'sort' | 'search' | 'sort&search' | undefined;
  columnType: ColumnType;
  columnSortType?: SortType | undefined;
  searchType?: SearchType;
  searchText?: string;
  fromValue?: string;
  toValue?: string;
}

export interface CellActionArray {
  columnDef : string,
  type : 'icon' | 'button' | 'link',
  cssClass  : string,
  required? : (name : string ,data:any) => boolean;
  name : string
}

export interface RowActionArray {
  cssClass : string,
  name: string,
  action: string
}

